import priceConvet from '@/components/PriceConvert/index.vue';
import sIcon from '@/components/SIcon/index.vue';
import isWeChatWeb from '@/utils/checkWebUserAgent';
// import plugins from '@/utils/globleComponents';
import '@/utils/rem.js';
import setInfoDecimal from '@/utils/setInfoDecimal';
import '@/utils/svgIcon.js';
import Vant, { Toast } from 'vant';
import 'vant/lib/index.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import "@/styles/basis.scss";
import "@/utils/setGlobalColor"

import './utils/checkWebUserAgent'
import './utils/VConsole'
// 设置微信小程序script
import './utils/setMapScript'
import './config/color.config'
import './libs/versionUpdate'

// const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

// if (isIOS) {
// 	window.history.pushState({}, 'title', '#');
// }

// 版本更新 跳转

// const VUE_APP_VERSION = require('../package.json').version;
// const vers = window.localStorage.getItem('Version');
// if (VUE_APP_VERSION !== vers) {
// 	store.dispatch('user/loginOut').then(() => {
// 		window.localStorage.setItem('Version', VUE_APP_VERSION);
// 		window.location.href = window.location.href
// 		this.$router.push('/login');
// 	});
// }

// 全局添加 ¥计算函数
Vue.prototype.$setInfoDecimal = setInfoDecimal;
Vue.prototype.$toast = Toast;
// 判断是否微信浏览器
Vue.prototype.$isWeChatWeb = isWeChatWeb;


Vue.use(Vant);

Vue.component('s-icon', sIcon);
Vue.component('price-convert', priceConvet)

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
